import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  List,
  ListSubheader,
  Popover,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "../Vendors/Vendors.css";
import DataTable from "../Tables/DataTable/DataTable";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import {
  ClearSelectionData,
  SelectionFilter,
} from "../../utilities/SelectionFilter";
import TableColumnModal from "../../common/TableColumnModal/TableColumnModal";
import ApiServices from "../../services/ApiServices";
import { useLoading } from "../../hooks/useLoader";
import {
  VENDOR_INTEGRATIONSOLUTION_LIST,
  VENDOR_INTEGRATIONSOLUTION_STATUS,
} from "../../constants/api-constants";
import { toast } from "react-toastify";
import { MenuListItems } from "../../common/Sidebar/MenuListItems";
import { SystemModulesEnum } from "../../constants/SystemUsers";
import {
  childModulePermissions,
  PermissionEnum,
} from "../../constants/permissionService";
import { useVendorContext } from "../Vendors/Vendor.context";
import Confirmation from "../../common/Confirmation/Confirmation";
import { STATUS_ENUM, TABS } from "../../constants/common";
import CheckboxList from "../../common/CheckboxList/CheckboxList";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import PropTypes from "prop-types";

/*istanbul ignore next */
const IntSolutionList = (props) => {
  const { showLoader } = useLoading();
  const { id } = useParams();
  const history = useHistory();
  useVendorContext();
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [tableColumnModalVisibility, setTableColumnModalVisibility] =
    useState(false);
  const [vendorTable, setVendorTableData] = useState([]);
  const [confirmation, setConfirmation] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [selectedSolution, setSelectedSolution] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const open2 = Boolean(anchorEl);

  const [query, setQuery] = useState({
    searchText: "",
    SortType: "desc",
    IgnorePaging: false,
    SortColumn: "userId",
    PageNumber: 1,
    PageSize: 10,
    Filter: {
      Status: selectedStatus,
    },
  });

  let vendorContactModuleId = MenuListItems.find(
    (item) => item.name === SystemModulesEnum.VENDORS,
  )?.moduleId;
  const vendorIntSolutionPermission = childModulePermissions(
    vendorContactModuleId,
    SystemModulesEnum.VENDOR_INTEGRATION_SOLUTION,
  );

  useEffect(() => {
    vendorSolutionList();
    setSelectionColumns();
  }, [query]);

  useEffect(() => {
    if (id && vendorIntSolutionPermission?.includes(PermissionEnum.LIST)) {
      vendorSolutionList();
    }
  }, []);

  const handleConfirmationOpen = (actionName, cnfMessage) => {
    setConfirmationMessage(cnfMessage);
    setConfirmation(true);
  };
  const handleConfirmationClose = () => {
    setConfirmationMessage("");
    setConfirmation(false);
  };

  const onSearchHandler = (event) => {
    ClearSelectionData();
    setTimeout(() => {
      setQuery((prevState) => ({
        ...prevState,
        PageNumber: 1,
        searchText: event.target.value,
      }));
    }, 1000);
  };

  const sortHandler = (sortOrder, sortBy) => {
    setQuery((prevState) => {
      if (prevState.SortColumn === sortBy) {
        return { ...prevState, SortType: sortOrder === "asc" ? "desc" : "asc" };
      }
      return { ...prevState, SortColumn: sortBy, SortType: "asc" };
    });
  };

  const handleChangePageNumber = (event, newPage) => {
    setQuery((prevState) => ({ ...prevState, PageNumber: newPage }));
  };

  /*istanbul ignore next */
  const pageSizeChangeHandler = (PageSize) => {
    setQuery((prevState) => ({
      ...prevState,
      PageSize: PageSize,
      PageNumber: 1,
    }));
  };

  const onEdit = (record) => {
    history.push(
      `/vendor/${props.vendorId}/solution/${record.integrationSolutionId}/edit`,
    );
  };

  const onView = (record) => {
    history.push(
      `/vendor/${props.vendorId}/solution/${record.integrationSolutionId}/view`,
    );
  };

  const onClickService = (vendor) => {
    props.setIntegrationSolutionId(vendor.integrationSolutionId);
    props.setSelectedSubTab(TABS.VENDOR_SERVICES);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onFilterStatusChangeHandler = (values) => {
    setSelectedStatus(values);
  };
  const clearFilterHandler = () => {
    setSelectedStatus([]);
  };

  const applyFilterHandler = () => {
    ClearSelectionData();
    setQuery((prevState) => ({
      ...prevState,
      PageNumber: 1,
      Filter: { Status: selectedStatus },
    }));
  };

  const onCheckboxChangeHandler = (e, value) => {
    const { checked } = e.target;
    if (value === "all") {
      setVendorTableData((items) => {
        SelectionFilter(items, "multiple", checked);
        return items.map((data) => ({ ...data, isChecked: checked }));
      });
    } else {
      setVendorTableData((items) =>
        items.map((user) => {
          let userRecord = { ...user };
          if (user.integrationSolutionId === value) {
            SelectionFilter(user, "single", checked, "integrationSolutionId");
            userRecord.isChecked = checked;
          }
          return userRecord;
        }),
      );
    }
  };

  const onCancelTableColumnSelection = () => {
    setSelectionColumns();
    setTableColumnModalVisibility(false);
  };

  const onSaveTableColumnSelection = (componentName, columns) => {
    let oldData = localStorage.getItem("selectedColumns")
      ? JSON.parse(localStorage.getItem("selectedColumns"))
      : null;
    if (oldData) {
      let data = { ...oldData, listOfSolutionDataColumns: columns };
      localStorage.setItem("selectedColumns", JSON.stringify(data));
    }
    setSelectionColumns();
    setTableColumnModalVisibility(false);
  };

  const setSelectionColumns = () => {
    let selectedCols = localStorage.getItem("selectedColumns")
      ? JSON.parse(localStorage.getItem("selectedColumns"))
      : null;
    let adminCols = selectedCols?.listOfSolutionDataColumns
      ? selectedCols?.listOfSolutionDataColumns
      : null;
    if (adminCols) {
      setSelectedColumns(adminCols);
    }
  };

  const onToggleHandler = async (
    column,
    userId,
    contentSubscriberStatus,
    e,
    selectedSolution,
  ) => {
    setSelectedSolution(selectedSolution);
    if (selectedSolution.status === 1) {
      handleConfirmationOpen(
        "Inactivate",
        "Are you sure you want to mark the Integration Solution as Inactive?",
      );
    } else {
      changeContentStatus(selectedSolution, STATUS_ENUM.ACTIVE);
    }
  };

  const changeContentStatus = async (vendorObj, status) => {
    try {
      const response = await ApiServices.httpPut(
        VENDOR_INTEGRATIONSOLUTION_STATUS,
        {
          integrationSolutionId: vendorObj.integrationSolutionId,
          status: Number(status),
        },
      );
      if (response.responseStatus.isSuccess) {
        toast.success(response.responseStatus.description);
        handleConfirmationClose();
        vendorSolutionList();
      } else {
        toast.error(response.responseStatus.error);
      }
    } catch (event) {
      toast.error("Internal server error");
    }
  };

  const vendorSolutionList = async () => {
    try {
      showLoader(true);
      const contactQuery = {
        ...query,
        Filter: { ...query.Filter, vendorId: props.vendorId },
      };
      const vendorData = await ApiServices.httpGet(
        `${VENDOR_INTEGRATIONSOLUTION_LIST}/${JSON.stringify(contactQuery)}`,
      );
      showLoader(false);
      if (vendorData.responseStatus.isSuccess) {
        setVendorTableData(vendorData?.result?.records);
        setTotalPages(vendorData?.result?.totalPages);
        setPageSize(vendorData?.result?.pageSize);
      } else {
        toast.error(vendorData.responseStatus.error);
      }
    } catch (e) {
      showLoader(false);
      toast.error();
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <Box mb={2} mt={-1} className="top-right-actions">
          <div className="add-welcome-widgets">
            <div>
              <Popover
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                id={"simple-popover"}
                open={open2}
                anchorEl={anchorEl}
                onClose={handleClose}
              >
                <div className="expanded-filter">
                  <div className="filter-options">
                    <List
                      sx={{
                        width: "100%",
                        maxWidth: 360,
                        bgcolor: "background.paper",
                      }}
                      component="nav"
                      aria-labelledby="nested-list-subheader"
                      subheader={
                        <ListSubheader
                          component="div"
                          id="nested-list-subheader"
                        >
                          Filters will be applied to your grid
                        </ListSubheader>
                      }
                    >
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <Typography sx={{ width: "33%", flexShrink: 0 }}>
                            Status
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <CheckboxList
                            id="status"
                            options={[
                              { value: 1, label: "Active" },
                              { value: 0, label: "Inactive" },
                            ]}
                            onChange={onFilterStatusChangeHandler}
                            selectedValues={selectedStatus}
                          />
                        </AccordionDetails>
                      </Accordion>
                    </List>
                  </div>
                  <div className="modal-footer">
                    <Button
                      variant="outlined"
                      className="action-button mr-4"
                      onClick={clearFilterHandler}
                    >
                      Clear
                    </Button>
                    <Button
                      variant="contained"
                      className="action-button"
                      onClick={() => {
                        applyFilterHandler();
                        handleClose();
                      }}
                    >
                      Apply
                    </Button>
                  </div>
                </div>
              </Popover>
            </div>
            {vendorIntSolutionPermission?.includes(PermissionEnum.CREATE) && (
              <Tooltip placement="bottom" title="Add New Integration Solution">
                <AddOutlinedIcon
                  name="add-icon"
                  onClick={() => {
                    history.push(`/vendor/${props.vendorId}/solution/new`);
                  }}
                />
              </Tooltip>
            )}
            <Tooltip placement="bottom" title="Filter">
              <FilterAltOutlinedIcon
                title="filter-icon"
                onClick={handleClick}
              />
            </Tooltip>
          </div>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box>
          <DataTable
            uniqueKey="integrationSolutionId"
            query={query}
            columns={selectedColumns}
            adminTable={vendorTable}
            onSearch={onSearchHandler}
            onSort={sortHandler}
            onPageSizeChange={pageSizeChangeHandler}
            handleChangePage={handleChangePageNumber}
            totalPages={totalPages}
            pageSize={pageSize}
            onCheckboxChange={onCheckboxChangeHandler}
            permissions={vendorIntSolutionPermission}
            onToggle={onToggleHandler}
            onEdit={(data) => onEdit(data)}
            onView={(data) => onView(data)}
            showToggle={true}
            showEdit={true}
            showView={true}
            showServiceIcon={true}
            onClickService={(data) => onClickService(data)}
            checkboxesNotRequired={true}
          />

          {tableColumnModalVisibility && (
            <TableColumnModal
              isOpen={tableColumnModalVisibility}
              onCancelTableColumnSelection={onCancelTableColumnSelection}
              onSaveTableColumnSelection={onSaveTableColumnSelection}
              selection={selectedColumns}
            />
          )}
          <Confirmation
            open={confirmation}
            handleClose={handleConfirmationClose}
            title={confirmationMessage}
            cancelButtonLabel="No"
            confirmButtonLabel="Yes"
            onCancel={() => {
              handleConfirmationClose();
            }}
            onConfirm={() => {
              changeContentStatus(selectedSolution, STATUS_ENUM.INACTIVE);
            }}
          />
        </Box>
      </Grid>
    </>
  );
};

IntSolutionList.propTypes = {
  vendorId: PropTypes.number.isRequired,
  vendorName: PropTypes.string,
  setIntegrationSolutionId: PropTypes.func.isRequired,
  setSelectedSubTab: PropTypes.func.isRequired,
  selectedSubTab: PropTypes.oneOf(Object.values(TABS)).isRequired,
  setShouldOpenServiceModal: PropTypes.func.isRequired,
  shouldOpenServiceModal: PropTypes.bool,
};
IntSolutionList.defaultProps = {
  shouldOpenServiceModal: false,
  vendorName: "",
};

export default IntSolutionList;
